import React, { useEffect, useRef, useState } from "react";
import Dropdown from "./dropdown";
import { downArrowHeadSvg, filterSvg } from "./svgs";

const SelectDropdown = ({
  selectedOption,
  options,
  onChange = () => {},
  disable = false,
  icon = <></>,
  containerStyles = "",
  dropdownClassName = "",
  dropdownOptionClassName = "",
  arrowIcon = (
    <>
      {downArrowHeadSvg(
        selectedOption?.icon?.height || 16,
        selectedOption?.icon?.width || 16,
        selectedOption?.icon?.fill || "none",
        selectedOption?.icon?.stroke || "#00000099"
      )}
    </>
  ),
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a ref for the dropdown

  const onOutsideClick = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onOutsideClick();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick]);

  const handleToggleDropdown = () => {
    if (disable) return;
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className={` w-full border p-2 flex justify-between items-center cursor-pointer ${containerStyles}`}
        onClick={handleToggleDropdown}
      >
        <div className="flex items-center gap-[5px]">
          <span className="mr-1">{icon}</span>
          <span className={`text-[#00000099] font-medium text-sm mr-2`}>
            {selectedOption?.text}
          </span>
        </div>
        {arrowIcon}
      </button>
      {isOpen && (
        <Dropdown
          selectedOption={selectedOption}
          handleOptionClick={(option) => {
            onChange(option);
            setIsOpen(false);
          }}
          dropdownOptions={options}
          dropdownClassName={dropdownClassName}
          dropdownOptionClassName={dropdownOptionClassName}
        />
      )}
    </div>
  );
};

export default SelectDropdown;
